import { render, staticRenderFns } from "./FavouriteJobs.vue?vue&type=template&id=4d5025d2&scoped=true"
import script from "./FavouriteJobs.vue?vue&type=script&lang=js"
export * from "./FavouriteJobs.vue?vue&type=script&lang=js"
import style0 from "./FavouriteJobs.vue?vue&type=style&index=0&id=4d5025d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5025d2",
  null
  
)

export default component.exports